import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE_URL = `${u}/stock-alert`;

export async function getStockAlertTriggers() {
  const res = await apiFetch(`${BASE_URL}/trigger`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function saveStockAlertTriggers(triggers) {
  const res = await apiFetch(`${BASE_URL}/trigger`, {
    method: "PUT",
    body: JSON.stringify(triggers || []),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Failed to save triggers");
  }
  return res.json();
}

export async function getStockAlertEvents() {
  const res = await apiFetch(`${BASE_URL}/events`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function evaluateStockAlerts() {
  const res = await apiFetch(`${BASE_URL}/evaluate`, { method: "POST" });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Alert evaluation failed.");
  }
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
